import Vue from 'vue'
import { queryService, storageService } from '@/services'
import { makeUser } from '@/util/apiHelper'
import { isNullOrUndefined } from '~/util/validators/baseComponentsValidators.js'

export const state = () => ({
  isDocumentsLoaded: false,
  status: '',
  user: {
    id: '',
    session_id: '',
    balance: 0,
    max_payout: 0,
    wager_balance: 0,
    phone: '',
    phone_code: '380',
    name: '',
    firstname: '',
    email: '',
    sex: null,
    is_test: false,
    is_email_verified: 0,
    is_email_verification_sent: 0,
    is_inn_verified: 0,
    is_phone_verified: 0,
    is_phone_verification_sent: 0,
    phone_verification_sent_code: '',
    phone_verification_sent_phone: '',
    birthday: '',
    bonuses: '',
    bonus_balance: 0,
    locked_balance: 0,
    is_payin_allowed: false,
    is_payout_allowed: false,
    selectedPaymentCard: {},
    payin_count: 0,
    is_chance_message_sent: 0,
    has_bonus_mob_login: false,
  },
  userDataStatus: false,
  token: null,
  guestUserToken: null,

  userSocialCb: {},
  userSocial: {},

  userPromotions: [],
  showLoader: true,
  restoreToken: '',
  hasUserTokenError: false,
  socialAuthEmailError: false,
  profileInfoLoading: false,
  activatedPromotions: [],
  profileInfoBonuses: {},
  abTests: {},
  userExistsData: {},
  lang: '',
  langUkRu: '',
  socialAuthNotAcceptError: false,
  isFetchingBonuses: false,
})

export const mutations = {
  SET_USER_SELECTED_PAYMENT_CARD(state, paymentCardUUID) {
    state.selectedPaymentCard = paymentCardUUID
  },
  setLang(state, lang) {
    state.lang = lang
    state.langUkRu = lang === 'ua' ? 'uk' : 'ru'
  },
  auth_request(state) {
    state.status = 'loading'
  },
  auth_success(state, payload) {
    state.status = 'success'
    state.token = payload.token
    state.user = payload.user

    state.guestUserToken = null
  },

  auth_error(state) {
    state.status = 'error'
  },
  SET_PROFILE_INFO: (state, { user, userDataStatus, abTests }) => {
    state.user = user
    state.userDataStatus = userDataStatus
    state.abTests = abTests
  },
  set_userSocialCb: (state, { userSocialCb }) => {
    state.userSocialCb = userSocialCb
  },
  logout(state) {
    state.logged = false
    state.status = ''
    state.token = null
    state.userDataStatus = false
    state.user = {
      id: '',
      session_id: '',
      balance: 0,
      max_payout: 0,
      wager_balance: 0,
      phone: '',
      phone_code: '380',
      name: '',
      email: '',
      sex: '',
      is_email_verified: Number,
      is_email_verification_sent: Number,
      is_phone_verified: Number,
      is_phone_verification_sent: Number,
      is_inn_verified: Number,
      phone_verification_sent_code: '',
      phone_verification_sent_phone: '',
      birthday: '',
      bonus: {
        bonus_amount: 0,
      },
      locked_balance: 0,
      is_payin_allowed: false,
      is_payout_allowed: false,
      payin_count: 0,
      is_chance_message_sent: 0,
      is_test: false,
    }
    storageService.removeToken()
    storageService.removeItem('uuid')

    try {
      window.dispatchEvent(new CustomEvent('userLogout'))
    }
    catch (e) { }
  },

  SET_PROFILE_PROMOTIONS: (state, userPromotions) => {
    const activePromotion = userPromotions.activatedPromotions.filter(
      item => item.bonus[0].status === 'active'
    )

    const notActivePromotion = userPromotions.activatedPromotions.filter(
      item => item.bonus[0].status !== 'active'
    )

    state.userPromotions = [
      // ...activePromotion,
      // ...notActivePromotion,
      ...userPromotions.promotions,
      ...userPromotions.announcedPromotions,
    ]
    state.showLoader = false
    state.activatedPromotions = userPromotions.activatedPromotions
  },

  SET_USER_SOCIAL: (state, { userSocial }) => {
    state.userSocial = userSocial
  },

  SET_USER_TOKEN: state => {
    state.token = storageService.getToken()
  },
  SET_RESTORE_TOKEN: (state, { restoreToken }) => {
    state.restoreToken = restoreToken
  },
  SET_USER_TOKEN_ERROR: (state, value) => {
    state.hasUserTokenError = value
  },
  SET_SOCIAL_AUTH_EMAIL_ERROR: (state, value) => {
    state.socialAuthEmailError = value
  },
  SET_SHOW_LOADER: (state, value) => {
    state.showLoader = value
  },
  TOGGLE_PROFILE_INFO_LOADING: (state) => {
    state.profileInfoLoading = !state.profileInfoLoading
  },
  setInfoBonuses: (state, payload) => {
    state.profileInfoBonuses = payload
  },
  userExistsData: (state, data) => {
    state.userExistsData = data
  },
  set_socialAuthNotAcceptError: (state, value) => {
    state.socialAuthNotAcceptError = value
  },
  set_userBalance(state, userBalance) {
    if (!isNullOrUndefined(userBalance.real)) {
      state.user.max_payout = String(userBalance.real / 100)
      state.user.balance = String(+state.user.max_payout + +state.user.bonus_balance)
    }
    if (!isNullOrUndefined(userBalance.bonus)) {
      state.user.bonus_balance = String(userBalance.bonus / 100)
      state.user.balance = String(+state.user.max_payout + +state.user.bonus_balance)
    }
    if (!isNullOrUndefined(userBalance.wager_balance)) {
      state.user.wager_balance = String(userBalance.wager_balance / 100)
    }
  },
  setIsFetchingBonuses(state, payload) {
    state.isFetchingBonuses = payload
  },
  resetUserPromotions(state) {
    state.userPromotions = []
  },
  resetActivatedPromotions(state) {
    state.activatedPromotions = []
  },
  setGuestUserToken(state, payload) {
    state.guestUserToken = payload
  },
  set_userDocumentsLoaded(state, isLoaded) {
    state.isDocumentsLoaded = isLoaded
  },
  set_userVefificationData(state, {
    is_email_verified,
    is_phone_verified,
    is_selfie_verified,
    is_passport_verified,
    verification_status,
  }) {
    state.user.is_email_verified = is_email_verified
    state.user.is_phone_verified = is_phone_verified
    state.user.is_selfie_verified = is_selfie_verified
    state.user.is_passport_verified = is_passport_verified
    state.user.verification_status = verification_status
  },
}

export const actions = {
  async logout({ commit, dispatch }) {
    Vue.$cookies.remove(`intercom-device-id-${this.$config.intercomId}`)
    Vue.$cookies.remove(`intercom-session-${this.$config.intercomId}`)
    storageService.removeItem('modalFirstLevel')
    this.$api.$commonToken = undefined
    dispatch('limits/actReset_limitsInfo', null, { root: true })
    dispatch('promotions/reset_newPromotions', null, { root: true })
    commit('logout')
  },
  SELECTED_PAYMENT_CARD: function({ commit }, paymentCardUUID) {
    commit('SET_USER_SELECTED_PAYMENT_CARD', paymentCardUUID)
  },
  act_userSocialCb: async function({ commit, dispatch }, params) {
    try {
      const res = await this.$api.auth.userSocialCb(params)
      const token = res.data.user?.token

      if (!token) {
        if (res.data.errors === 'not_accept') {
          commit('set_socialAuthNotAcceptError', true)
          return
        }
        if (res.data.errorCode === 422 && res.data.errorMessage === 'Unsupported Email') {
          dispatch('SOCIAL_AUTH_EMAIL_ERROR', true)
          return
        }
        dispatch('UPDATE_USER_TOKEN_ERROR', true)
        return
      }
      else {
        const user = res.data.user
        storageService.saveToken(token)
        storageService.setItem('tokenTimestamp', new Date()
          .getTime())
        commit('auth_success', { token, user })
        await dispatch('PROFILE_INFO')
        dispatch('promotions/fetch_newPromotions', null, { root: true })
        return res
      }
    }
    catch (error) {
      if (error.data.errorCode === 401 && error.data.errorMessage === 'email_not_found') {
        dispatch('SOCIAL_AUTH_EMAIL_ERROR', true)
      }
      const tokenTimestamp = storageService.getItem('tokenTimestamp')
      const currentTime = new Date()
        .getTime()
      if (currentTime - tokenTimestamp >= 2500) {
        storageService.removeToken()
      }
      throw error
    }
  },

  async PROFILE_INFO({ commit, getters, dispatch }) {
    try {
      commit('TOGGLE_PROFILE_INFO_LOADING')
      const isFirstTimeFetchingProfileInfo = !getters['userId']
      const affise = storageService.getAffise()
      const res = await this.$api.profile.profileInfo({ affise })
      if (!res.data.user) commit('logout')
      if (affise) {
        storageService.removeAdw()
        storageService.removeAffise()
        queryService.removeAll()
      }
      const userData = makeUser(res.data.user)
      commit('SET_PROFILE_INFO', { user: userData, userDataStatus: res.data.status, abTests: res.data.ab_tests })

      if (isFirstTimeFetchingProfileInfo) {
        dispatch('promotions/fetch_newPromotions', null, { root: true })
      }
      return res.data.user
    }
    catch (error) { }
    finally {
      commit('TOGGLE_PROFILE_INFO_LOADING')
    }
  },
  async PROFILE_PROMOTIONS({ commit, getters }) {
    try {
      if (getters.isFetchingBonuses) return
      commit('setIsFetchingBonuses', true)
      commit('SET_SHOW_LOADER', true)
      const res = await this.$api.userPromotions.profilePromotions()
      commit('SET_PROFILE_PROMOTIONS', res.data)
    }
    finally {
      commit('SET_SHOW_LOADER', false)
      commit('setIsFetchingBonuses', false)
    }
  },

  RESTORE_BY_TOKEN: async function(context, { token }) {
    const res = await this.$api.users.getAuthByTempToken({ token })
    context.commit('SET_RESTORE_TOKEN', { restoreToken: res.data })
  },
  USER_SOCIAL: async function(context, social) {
    const res = await this.$api.auth.userSocial({ social })
    context.commit('SET_USER_SOCIAL', { userSocial: res.data })
    return true
  },
  UPDATE_USER_TOKEN_ERROR: function({ commit }, value) {
    commit('SET_USER_TOKEN_ERROR', value)
  },
  SEND_UTM: async function(context, cookieUtm) {
    const dataCookieUtm = { utm: cookieUtm }
    await this.$api.users.sendUtm({ utm: cookieUtm })
    storageService.removeUtm()
  },
  SOCIAL_AUTH_EMAIL_ERROR: function({ commit }, value) {
    commit('SET_SOCIAL_AUTH_EMAIL_ERROR', value)
  },
  async fetchInfoBonuses({ commit }) {
    try {
      const { data } = await this.$api.profile.profileInfoBonuses()

      if (!data || !data.result) {
        throw new Error('Invalid data structure')
      }
    }
    catch (error) {
      console.error('Failed to fetch info bonuses:', error)
    }
  },
  act_userBalance({ commit }, p) {
    commit('set_userBalance', p)
  },
  async act_getGuestToken({ commit }) {
    try {
      const { data } = await this.$api.guestUser.getGuestUserToken()

      commit('setGuestUserToken', data.token)
    }
    catch (error) {
      console.error('Failed to fetch guest token:', error)
    }
  },

  async set_userDocumentsLoaded({ commit }) {
    commit('set_userDocumentsLoaded', true)
  },
  async act_setUserVefificationData({ commit }, {
    is_email_verified,
    is_phone_verified,
    is_selfie_verified,
    is_passport_verified,
    verification_status,
  }) {
    commit('set_userVefificationData', {
      is_email_verified,
      is_phone_verified,
      is_selfie_verified,
      is_passport_verified,
      verification_status,
    })
  },
}

export const getters = {
  GET_USER_SELECTED_PAYMENT_CARD: (state) => state.selectedPaymentCard,
  isLoggedIn: (state) => !!state.token,
  token: (state) => state.token,
  isFetchingBonuses: (state) => state.isFetchingBonuses,
  user: (state) => state.user,
  userId: (state) => state.user.id,
  GET_PROFILE_PROMOTIONS: (state) => state.userPromotions,
  GET_USER_SOCIAL: (state) => state.userSocial,
  isUserLoaded: (state) => state.userDataStatus,
  GET_USER_TOKEN_ERROR: (state) => state.hasUserTokenError,
  GET_SOCIAL_AUTH_EMAIL_ERROR: (state) => state.socialAuthEmailError,
  GET_RESTORE_TOKEN: (state) => state.restoreToken,
  GET_SHOW_LOADER: (state) => state.showLoader,
  langUkRu: (state) => state.langUkRu,
  isUserNothingVerified: (state) => !state.user.is_email_verified
    && !state.user.is_phone_verified
    && !state.user.is_passport_verified
    && !state.user.is_selfie_verified,
  isUserSomethingVerified: (state) => !!(state.user.is_email_verified
    || state.user.is_phone_verified
    || state.user.is_passport_verified
    || state.user.is_selfie_verified),
  isUserDocumentsVerified: (state) => !!(state.user.is_passport_verified
    && state.user.is_selfie_verified),
  isUserVerified: (state, getters) => !!(getters.isUserDocumentsVerified
    && (state.user.is_email_verified || state.user.is_phone_verified)),
  isUserPhoneOrEmailVerified: (state) => state.user.is_email_verified || state.user.is_phone_verified,
  isFullUserVerified: (state) => state.user.is_email_verified
    && state.user.is_phone_verified
    && state.user.is_passport_verified
    && state.user.is_selfie_verified,
  /** New Getters */
  maxPayout: (state) => state.user.max_payout,
  balance: (state) => state.user.balance,
  bonusBalance: (state) => state.user.bonus_balance,
  wagerBalance: (state) => state.user.wager_balance,
  profileInfoLoading: (state) => state.profileInfoLoading,
  activatedPromotions: (state) => state.activatedPromotions,
  profileInfoBonuses: (state) => state.profileInfoBonuses || {},
  abTests: (state) => state.abTests,
  userExistsData: (state) => state.userExistsData,
  getToVerification: (_, getters) => {
    const to = {}
    if (!getters.user.is_passport_verified || !getters.user.is_selfie_verified) {
      to.query = { type: 'document-select' }
    }
    else if (!getters.user.is_phone_verified || !getters.user.is_email_verified) {
      to.query = { type: 'contacts' }
    }
    return ($paths) => {
      to.path = $paths.verifications
      return to
    }
  },
  get_socialAuthNotAcceptError: (state) => state.socialAuthNotAcceptError,
  get_isLangUa: (state) => state.lang === 'ua',
  get_guestUserToken: (state) => state.guestUserToken,
  get_isDocumentsLoaded: (state) => state.isDocumentsLoaded,
}
